import { TbPlus, TbArrowRight } from 'react-icons/tb'
import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import clsx from 'clsx'
import classes from './SolutionHowItWorks.module.scss'

export const SolutionHowItWorks = ({
  steps,
  guideLink,
}: {
  steps: string[]
  guideLink?: string
}) => {
  return (
    <Block
      as={'section'}
      variant={'solidMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <TbPlus className={clsx(classes.icon, classes.icon__topLeft)} />
      <TbPlus className={clsx(classes.icon, classes.icon__topRight)} />
      <TbPlus className={clsx(classes.icon, classes.icon__bottomLeft)} />
      <TbPlus className={clsx(classes.icon, classes.icon__bottomRight)} />
      <Heading as={'h2'} size={'xl'} center className={classes.title}>
        How it works
      </Heading>
      <ul className={clsx(classes.list, guideLink && classes.list__guide)}>
        {steps.map((step, idx) => (
          <li key={idx} className={classes.item}>
            <Text as={'span'} className={classes.number}>
              {`0${idx + 1}`}
            </Text>
            <Text size={'lg'}>{step}</Text>
          </li>
        ))}
        {guideLink && (
          <li key={'link'} className={clsx(classes.item, classes.item__guide)}>
            <div className={classes.linkWrapper}>
              <Link
                href={guideLink}
                target={'_blank'}
                type='noLine'
                className={classes.link}
              >
                Read detailed guide
              </Link>
              <TbArrowRight className={classes.icon__arrow} />
            </div>
          </li>
        )}
      </ul>
    </Block>
  )
}
